<template>
  <div class="mentIndex">
    <div class="home_con">
       <div class="moment"><Menthu /></div>
      <div class="mentCon">
        <div class="ment_title">公共信息交换规范</div>
        <p>1.范围</p>
        <span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本部分规定了电动汽车充换电业务信息服务交换规范，涵盖公共信息交换的功能描述、信息模型及接口协议，实现《电动汽车充换电服务信息交换
          第1部分：总则》公共信息接口（Icomm）。<br />
             
          &nbsp;&nbsp;&nbsp;本部分适用于归属不同运营商的电动汽车充换电运营服务平台之间的充换电服务信息交换，以及电动汽车充换电运营服务平台与第三方服务及管理平台之间的信息交换。</span
        >
        <p>2.规范性引用文件</p>
        <span
          >下列文件对于本文件的应用是必不可少的。凡是注日期的引用文件，仅所注日期的版本适用于本文件。凡是不注日期的引用文件，其最新版本（包括所有的修改单）适用于本文件。<br />
          GB/T 19596-2004 电动汽车术语<br />
          GB/T 29317-2012 电动汽车充换电设施术语<br />
          GB/T 2659-2000 世界各国和地区名称代码<br />
          GB/T 2260-2002 中华人民共和国行政区划代码<br />
          GB/T 18391.1-2002
          信息技术数据元的规范与标准化第1部分：数据元的规范与标准化框架<br />
          GB/T 2261.1-2003 个人基本信息分类与代码<br />
          GB/T 7408-2005 数据元和交换格式信息交换日期和时间表示法
        </span>
        <p>3.术语和定义</p>
        <span
          >参见《电动汽车充换电服务信息交换第1部分总则》第3章术语和定义</span
        >
        <p>4.功能描述</p>
        <small>公共信息接口共支持3个功能，分别是：</small>
        <span
          >获取充换电设施信息:<br />获取充换电设施信息是指支持数据需求方可以查询基础设施运营商的充电站信息，查询充电站的范围是双方提前约定好的充电站范围。需要支持全部查询和增量查询的方式。<br /><br />同步充电设备运行状态:<br />
          同步充电设备运行状态是实现数据需求方将基础设施运营商的充电站的运行状态同步到数据需求方。<br /><br />收集充电站统计信息:<br />
          收集充电站统计信息是数据需求方可以查询基础设施运营商的某些场站运行情况的统计信息。<br />
        </span>
        <p>5.公共信息对象</p>
        <small> 5.1　公共信息对象关系定义</small>
        <span
          >公共信息的对象包括：充电运营商信息、充电站信息、充电设备信息、充电设备接口信息、充电站统计信息、充电设备接口统计信息、充电站实时状态、充电设备接口实时状态。相关实体及其之间的关系如图1所示。</span
        >
        <img class="pc_img" src="@/assets/menthu/2/1.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/1.png" alt="" />
        <span>
          如图5.1所示，一个充电运营商至少运营一个充电站，每个充电站至少包含一个充电设备，每个充电设备会有一个和多个充电接口。</span
        ><br /><br />
        <span>
          充换电设施的实时状态，应该以充电设备接口的实时状态为最小上报单位，在批量查询的时候，为了提高效率，可以以充电站为单位，查询对应的充电设备的实时状态。</span
        ><br /><br />
        <span> 在进行数据统计时，应以某个充电站为单位，定期查询统计数据。</span>
        <small>5.2　设备运营商信息（OperatorInfo）</small>
        <small
          >用于描述设备运营商的一些基础信息，其中运营商ID使用组织机构代码（去掉“-”符号的9位字符，下文提及组织机构代码与此相同），运营商电话至少填写一个，方便用户联系运营商。</small
        >
        <small>详细定义请参见表5.1：</small>
        <img class="pc_img" src="@/assets/menthu/2/2.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/2.png" alt="" />
        <span>
          其中对于新营业执照(三码合一)组织机构代码为社会信用代码去掉前八位和最后一位，中间的数字</span
        >
        <small> 5.3　充电站信息(StationInfo)</small>
        <span>
          用于描述充电站的信息，包含充电站的基本信息、服务信息、支付信息等，其中基本信息的设备所属方ID为充电设备所属方的组织机构代码，如果不是代运营充电站，应填入和运营商ID一样的值。<br /><br />站点类型分为三大类：公共、个人、专用、其他，其中专用里面有：公交、环卫、物流、出租车。</span
        >
        <img class="pc_img" src="@/assets/menthu/2/3.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/3.png" alt="" />
        <img class="pc_img" src="@/assets/menthu/2/4.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/4.png" alt="" />
        <img class="pc_img" src="@/assets/menthu/2/5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/5.png" alt="" />
        <small>5.4　充电设备信息(EquipmentInfo)</small>
        <span
          >对充电设备的描述，包含设备编码、设备生厂商组织机构代码、设备型号、设备生产日期、设备类型、充电设备经纬度等。</span
        >
        <img class="pc_img" src="@/assets/menthu/2/6.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/6.png" alt="" />
        <small>5.5　充电设备接口信息(ConnectorInfo)</small>
        <span>
          对充电设备接口的基本信息对象的描述，包含充电设备接口编码、充电设备接口名称、充电设备接口类型、额定电压、额定电流、额定功率等。<br /><br />如果设备为交流，其中额定电压上限以及额定电压下限可填入一样的值。<br /><br />详细定义请参见表5.4：</span
        >
        <img class="pc_img" src="@/assets/menthu/2/7.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/7.png" alt="" />

        <small>5.6　充电设备接口状态（ConnectorStatusInfo）</small>
        <span>
          对充电设备接口实时状态对象的描述，包含充电设备接口编码、充电设备接口状态等。<br /><br />详细定义请参见表5.5：</span
        >
        <img class="pc_img" src="@/assets/menthu/2/8.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/8.png" alt="" />
        <small>5.7　充电站状态信息（StationStatusInfo）</small>
        <img class="pc_img" src="@/assets/menthu/2/9.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/9.png" alt="" />

        <small> 5.8　充电站统计信息（StationStatsInfo）</small>
        <span>
          对充电站进行统计分析时使用的对象，包含站点编号、开始日期、结束日期，运营商累计电量、设备编码、充电设备接口编码以及充电设备接口累计电量等。</span
        >
        <img class="pc_img" src="@/assets/menthu/2/10.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/10.png" alt="" />
        <small> 5.9　充电设备统计信息(EquipmentStatsInfo)</small>
        <span>
          对充电站设备进行统计分析时使用的对象，统计某个充电设备的充电电量。<br /><br />详细定义请参见表5.8：</span
        >
        <img class="pc_img" src="@/assets/menthu/2/11.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/11.png" alt="" />
        <small> 5.10　充电设备接口统计信息（ConnectorStatsInfo）</small>
        <span
          >对充电站设备接口进行统计分析时使用的对象，统计某个充电设备接口的充电电量等。<br /><br />详细定义请参见表5.9：</span
        >
        <img class="pc_img" src="@/assets/menthu/2/12.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/12.png" alt="" />
        <p>6.接口规范</p>

        <small> 6.1　概述</small>
        <span
          >为了满足上述业务流程的定义，一共有4个接口，分别为:<br /><br />查询充电站信息<br /><br />查询统计信息<br /><br />设备状态变化<br /><br />设备状态查询</span
        >

        <small>6.2　查询充电站信息</small>
        <small>6.2.1　概述</small>
        <span>此接口用于查询运营商的充电站的信息。</span>
        <small> 6.2.2　接口定义</small>
        <span
          >接口名称：query_stations_info<br /><br />接口使用方法：由充电运营商方实现此接口，数据需求方调用。<br /><br />查询时需要比对电站、充电设备、充电接口的基本信息的最后修改时间，三者只要有一处修改，就认为是最新修改时间，然后与输入参数lastQueryTime进行对比。</span
        >
        <small>6.2.3　输入参数</small>
        <span>输入参数定义请参见表6.1：</span>
        <img class="pc_img"  src="@/assets/menthu/2/13.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/13.png" alt="" />
        <small>6.2.4　返回值</small>
        <span>返回值定义请参见表6.2：</span>
        <img class="pc_img"  src="@/assets/menthu/2/14.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/14.png" alt="" />
        <small>6.2.5　示例</small>

        <img class="pc_img" src="@/assets/menthu/5/2- 6.2.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/2-6.2.5.png" alt="" />
        <small> 6.3　设备状态变化推送</small>
        <small>6.3.1　概述</small>
        <span> 当设备状态发生变化，推送最新的状态通知到合作方</span>
        <small> 6.3.2　接口定义</small>
        <span>
          接口名称： notification_stationStatus<br /><br />接口使用方法：由数据需求方实现此接口，充电运营商方调用。</span
        >
        <small> 6.3.3　输入参数</small>
        <span>输入参数定义请参见表6.3：</span>
        <img class="pc_img"  src="@/assets/menthu/2/15.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/15.png" alt="" />
        <small>6.3.4　返回值</small>
        <span>返回值定义请参见表6.4：</span>
        <img class="pc_img" src="@/assets/menthu/2/16.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/16.png" alt="" />
        <small>6.3.5　示例</small>
        <span>  {           "Status": 0,         }</span>
        <small>6.4　设备接口状态查询</small>
        <small>6.4.1　概述</small>
        <span>此接口用于批量查询设备实时状态</span>
        <small>6.4.2　接口定义</small>
        <span
          >接口名称： query_station_status<br /><br />接口使用方法：由充电运营商方实现此接口，数据需求方调用。</span
        >
        <small>6.4.3　输入参数</small>
        <span> 输入参数定义请参见表6.5：</span>
        <img class="pc_img"  src="@/assets/menthu/2/17.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/17.png" alt="" />

        <small> 6.4.4　返回值</small>
        <span>返回值定义请参见表6.6：</span>
        <img class="pc_img" src="@/assets/menthu/2/18.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/18.png" alt="" />
        <small> 6.4.5　示例</small>

        <img class="pc_img"  src="@/assets/menthu/5/2- 6.4.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/2- 6.4.5.png" alt="" />
        <small> 6.5　查询统计信息</small>
        <small>6.5.1　概述</small>
        <span> 此查询用于定期获取每个充电站，在某个周期内的统计信息</span>
        <small> 6.5.2　接口定义</small>
        <span
          >接口名称： query_station_stats<br /><br />接口使用方法：由充电运营商方实现此接口，数据需求方调用。</span
        >
        <small>6.5.3　输入参数</small>
        <span>输入参数定义请参见表6.7：</span>
        <img class="pc_img" src="@/assets/menthu/2/19.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/19.png" alt="" />
        <small> 6.5.4　返回值</small>
        <span>返回值定义请参见表6.8：</span>
        <img class="pc_img" src="@/assets/menthu/2/20.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/20.png" alt="" />
        <small> 6.5.5　示例</small>

        <img class="pc_img" src="@/assets/menthu/5/2-6.5.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/2-6.5.5.png" alt="" />
        <p>附　录　A</p>

        <span>（规范性附录）<br /><br />公共信息交换的业务流程</span>
        <small>A.1　概述</small>
        <span
          >针对本部分需要支持的功能，可以采用以下业务流程实现。<br /><br />备案充换电设施信息流程<br /><br />同步充电设备运行状态流程<br /><br />收集充电站统计信息流程</span
        >
        <small> A.2　备案充换电设施信息</small>
        <img class="pc_img" src="@/assets/menthu/2/21.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/21.png" alt="" />
        <span>
          如图A.1所示：数据需求方可定期调用充电运营商的“查询充电站”的接口，查询所有充电站的信息。同时在一定的周期内，按照一定频率，定期调用充电运营商的“查询充电站”的接口来更新充电站的最新的信息。<br /><br />因为电站的数量较大，“查询充电站”接口应提供分页的支持。以保证接口调用时不会因为充电站信息的数据量太大造成接口调用超时等问题。</span
        >
        <small> A.3　设备状态同步流程</small>
        <img class="pc_img"  src="@/assets/menthu/2/22.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/22.png" alt="" />
        <span>
          如图A.2所示：数据需求方按照一定周期，通过调用充电运营商的“设备状态查询”的接口，更新所有电站的充电设备接口状态。由于运营商电站数量较多，应在每次系统初始化的时候调用。<br /><br />在两次调用周期期间，当充电设备接口状态、车位状态、地锁状态发生变化时，充电运营商应把此充电设备接口的最新状态立刻通过调用数据需求方的“设备状态变化”接口，告知数据需求方某一个充电设备接口的状态发生了变化。<br /><br />若在充电中时，当充电设备接口状态、车位状态、地锁状态的变化推送给给数据需求方。</span
        >
        <small>A.4　收集充电站统计数据流程</small>
        <img class="pc_img" src="@/assets/menthu/2/23.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/2/23.png" alt="" />
        <span>
          如图A.3所示：数据需求方应定期获取电站的统计信息，这个周期是由数据需求方决定。调用时，应针对每一个电站调用充电运营商的“查询统计信息”的接口，查询运营商信息。</span
        >
        
      </div>
    </div>
  </div>
</template>


<script>
import Menthu from "@/components/menthu";
export default {
  components: {
    Menthu,
  },
};
</script>

<style scoped>
.home_con {
  display: flex;
  text-align: left;
}
small {
  font-family: Helvetica;
  margin-top: 24px;
}
.mentCon{
   margin-top:10px;
}
.mentCon .text_hh {
  margin-top: 12px;
  display: flex;
  font-size: 12px;
  font-family: Helvetica;
  color: #191c27;
  line-height: 18px;
}
</style>


// WEBPACK FOOTER //
// src/page/document/documentj.vue